import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=45dc4f4c&scoped=true"
import script from "./WithdrawModal.vue?vue&type=script&lang=js"
export * from "./WithdrawModal.vue?vue&type=script&lang=js"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=45dc4f4c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc4f4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45dc4f4c')) {
      api.createRecord('45dc4f4c', component.options)
    } else {
      api.reload('45dc4f4c', component.options)
    }
    module.hot.accept("./WithdrawModal.vue?vue&type=template&id=45dc4f4c&scoped=true", function () {
      api.rerender('45dc4f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Modal/WithdrawModal.vue"
export default component.exports